import React, { Component } from 'react';

import {localization} from '../../Frames/localization'
import { authenticationService } from '../../Authorization/_services';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { hasActivateCard } from '../../Frames/hasActivateCard'

import {messageWindowFixed} from '../../Elements/Snackbar/fixedMessageWindow'
import FixedMessageWindow from '../../Elements/Snackbar/fixedMessageWindow'

import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import {ThemeAppBar} from '../../../src/App'
import { ThemeProvider } from "@material-ui/styles";

//Элементы
import User from './user'
import Label from '../../Elements/Label/labels'
//Icons
import ViewListIcon from '@material-ui/icons/ViewList';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import NightsStayIcon from '@material-ui/icons/NightsStay';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LanguageIcon from '@material-ui/icons/Language';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

//Панель навигации(для адаптива)
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
//Выпадающее меню(для адаптива)
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import './navigation.css';
import './navigationAdaptive.css';
import i18next from 'i18next';
import {ThemeSwitch, themeColorLang,themeColorText} from '../../../src/App'

//settings
import {AppliedSettings} from '../../App'

const baseUrl = process.env.PUBLIC_URL;
const requestOptionsExit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("")
}
class Navigation extends Component
{      
    constructor(props){
        super(props);
        this.state = {
            selectedIndex: this.props.selectedIndex,
            hasActivatedCard: false,
            isLoaded: false,
            key: undefined
        }
        this.ChangeLanguage = this.ChangeLanguage.bind(this);
        this.handleListItemClick = this.handleListItemClick.bind(this)
       
      };
    componentWillMount() {
        try{
        var data = {
            cardCode: authenticationService.currentUserValue.data.cookies.cardCode,
            clientLogin: authenticationService.currentUserValue.data.cookies.clientLogin
        }
        
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
        fetch(`/api/cookiescheck`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindowFixed.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
               if(response.data != "success")
               {
                 authenticationService.logoutCookiesNotEqual();
                 return <Redirect to={{ pathname: baseUrl + '/login'}}></Redirect>
               }
        })
        }catch{
            authenticationService.logoutCookiesNotEqual();
            return <Redirect to={{ pathname: baseUrl + '/login'}}></Redirect>
        }
    }
    componentDidMount()
    {
        hasActivateCard.requestCheckActivateCard(requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindowFixed.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
                this.setState({ hasActivatedCard: response.data, isLoaded: true})
                messageWindowFixed.OpenMessage("info", localization.GetTranslate('Navigation.NotActivateCard'))
                if(response.data == true)
                {
                    if(AppliedSettings.redirect_to_client_info == true)
                    {
                        this.setState({ selectedIndex: 5,key: Math.random()})
                    }else
                    {
                        this.setState({ key: Math.random()})
                    }
                }
        })
            


    }
    onExitApp(event){
        authenticationService.logout();
        event.preventDefault();
      }    
    ChangeLanguage(){
        localization.ChangeLanguage();
        this.forceUpdate();
      }   
    handleListItemClick(event, index){
        
        hasActivateCard.requestCheckActivateCard(requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindowFixed.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
                this.setState({ hasActivatedCard: response.data, isLoaded: true})
                messageWindowFixed.OpenMessage("info", localization.GetTranslate('Navigation.NotActivateCard'))
                
                if(response.data == true)
                {
                    if(AppliedSettings.redirect_to_client_info == true)
                    {
                    this.setState({ selectedIndex: 5,key: Math.random()})
                    }else
                    {
                        this.setState({ key: Math.random()})
                    }
                }
        })
    //localStorage.setItem('selectedIndex', index);
    this.setState({selectedIndex: index});
    this.forceUpdate()
  };
    render(){
        const {selectedIndex, isLoaded, hasActivatedCard} = this.state;
        const currentUser = authenticationService.currentUserValue;
        var theme = this.props.theme;
        var tr = {
            Menu: localization.GetTranslate('Navigation.Menu'),
            Personalaccount: localization.GetTranslate('Navigation.Personal account'),
            Statistics: localization.GetTranslate('Navigation.Statistics'),
            Operations: localization.GetTranslate('Navigation.Operations'),
            Cashback: localization.GetTranslate('Navigation.Cashback'),
            TransferMoney: localization.GetTranslate('Navigation.TransferMoney'),
            Limits: localization.GetTranslate('Navigation.Limits'),
            Profile: localization.GetTranslate('Navigation.Profile'),
            Security: localization.GetTranslate('Navigation.Security'),
            NightMode:  localization.GetTranslate('Navigation.NightMode'),
            About: localization.GetTranslate('Navigation.About'),
            Exit:  localization.GetTranslate('Navigation.Exit')
        } 
        const ukr = {
            color: i18next.options.lng === 'ru' ? "" : themeColorLang.color,
            fontWeight: i18next.options.lng === 'ru' ? "" : "bold",
            textDecorationLine: i18next.options.lng === 'ru' ? "none" :'underline',
            textDecorationStyle: 'solid',
            textDecorationColor: themeColorLang.color,
            cursor: "pointer"
            };
        const rus = {
            color: i18next.options.lng === 'uk' ? "" : themeColorLang.color,
            fontWeight: i18next.options.lng === 'uk' ? "" : "bold",
            textDecorationLine: i18next.options.lng === 'uk' ? "none" :'underline',
            textDecorationStyle: 'solid',
            textDecorationColor: themeColorLang.color,
            cursor: "pointer"
        };
        return(
            <div>
            {isLoaded && hasActivatedCard == true &&  
            <div style={{position: 'absolute'}} key={this.state.key}>
                    {AppliedSettings.redirect_to_client_info &&    
                    <Redirect to={{ pathname: baseUrl + '/clientinfo'}} />
                    }
                    <FixedMessageWindow key={this.state.key} ></FixedMessageWindow>   
            </div>
            }  
            <div className="navigationShow">       
              
            <div className="navigation_menu">  
                <List>
                    {AppliedSettings.show_personal_profile_panel &&
                    <div className="ItemCabinet">
                        <label style={{color: themeColorText.color}} className="LabelCabinet">{tr.Personalaccount}</label>
                    </div>
                    }
                    {!AppliedSettings.show_personal_profile_panel &&
                    <div className="ItemLogoCabinet">
                        {/* <label style={{color: themeColorText.color}} className="LabelCabinet">{tr.Personalaccount}</label> */}
                            {theme === "light" &&
                              <img alt="...loading..." height="38" style={{maxWidth: 250}} src={baseUrl + "/images/loyalty_logo_light_navigation.png"}></img>
                            }
                            {theme === "dark" &&
                              <img alt="...loading..." height="38" style={{maxWidth: 250}} src={baseUrl + "/images/loyalty_logo_dark_navigation.png"}></img>
                            }
                    </div>
                    }
                    <Divider />
                    <div>
                        <User show_username_logo_fio={AppliedSettings.show_username_logo_fio} user={currentUser}></User>
                    </div>
                    {AppliedSettings.show_statistics_page &&
                    <Link to={baseUrl + "/stats"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 0}
                        onClick={event => this.handleListItemClick(event, 0)}
                        >
                            <ListItemIcon>
                                <ViewListIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Statistics} />
                        </ListItem>
                    </Link>
                    }
                    {AppliedSettings.show_operations_page &&
                    <Link to={baseUrl + "/operations"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 1}
                        onClick={event => this.handleListItemClick(event, 1)}
                        >
                            <ListItemIcon>
                                <WatchLaterIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Operations} />
                        </ListItem>
                    </Link>
                    }
                    {AppliedSettings.show_cashback_page &&
                    <Link to={baseUrl + "/cashback"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 2}
                        onClick={event => this.handleListItemClick(event, 2)}
                        >
                            <ListItemIcon>
                                <MonetizationOnIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Cashback} />
                        </ListItem>
                    </Link>
                    }
                    {AppliedSettings.show_transferring_funds_page &&
                    <Link to={baseUrl + "/transferringFunds"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 3}
                        onClick={event => this.handleListItemClick(event, 3)}
                        >
                            <ListItemIcon>
                                <SyncAltIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.TransferMoney} />
                        </ListItem>
                    </Link>
                    }
                    {AppliedSettings.show_limits_page &&
                    <Link to={baseUrl + "/limits"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 4}
                        onClick={event => this.handleListItemClick(event, 4)}
                        >
                            <ListItemIcon>
                                <CreditCardIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Limits} />
                        </ListItem>
                    </Link>
                    }
                    {AppliedSettings.show_clientInfo_page &&
                    <Link to={baseUrl + "/clientInfo"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 5}
                        onClick={event => this.handleListItemClick(event, 5)}
                        >
                            <ListItemIcon>
                                <SupervisorAccountIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Profile} />
                        </ListItem>
                    </Link>
                    }   
                    {AppliedSettings.show_security_page &&
                    <Link to={baseUrl + "/security"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 6}
                        onClick={event => this.handleListItemClick(event, 6)}
                        >
                            <ListItemIcon>
                                <VerifiedUserIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Security} />
                        </ListItem>
                    </Link>
                    }
                </List>
                <Divider />
                
                <List>
                    {AppliedSettings.show_night_thema &&
                        <ListItem className="LinkNavigationBG"> 
                            <ListItemIcon>
                                <NightsStayIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText id="switch-list-label-nightmode" primary={tr.NightMode} />
                            <ListItemSecondaryAction>
                                <ThemeSwitch 
                                onClick={this.props.changeTheme}
                                checked={theme == 'light' | theme == null ? false : true}
                                color="primary"
                                />
                            </ListItemSecondaryAction>
                        </ListItem> 
                    }
                    {AppliedSettings.show_language_panel &&
                    <Link className="LinkNavigation">
                    <ListItem className="LinkNavigationBG" button onClick={this.ChangeLanguage}>
                            <ListItemIcon>
                                <LanguageIcon className="IconMenu"/>
                            </ListItemIcon>
                            <Label style={ukr} textLabel={AppliedSettings.language_first}></Label>
                            <Label className="LabelLang" textLabel="/"></Label>
                            <Label style={rus} textLabel={AppliedSettings.language_second}></Label>
                        </ListItem>     
                    </Link>
                    }   
                    <Divider />        
                    <Link to={baseUrl + "/about"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 7}
                        onClick={event => this.handleListItemClick(event, 7)}
                        >
                            <ListItemIcon>
                                <InfoOutlinedIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.About} />
                        </ListItem>
                    </Link>
                    {[tr.Exit].map((text) => (
                    <ListItem className="LinkNavigationBG" button key={text} onClick={this.onExitApp}>
                        <ListItemIcon>{<ExitToAppIcon className="IconMenu"/>}</ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItem>
                    ))}
                </List>
            </div>
            </div>
            <div className="NavPanelMobile">
                <MenuAppBar
                theme={theme}
                ukr={ukr}
                rus={rus}
                tr={tr}
                selectedIndex={selectedIndex}
                ChangeLanguage = {this.ChangeLanguage}
                handleListItemClick = {this.handleListItemClick}
                changeTheme = {this.props.changeTheme}
                onExitApp = {this.onExitApp}
                user={authenticationService.currentUserValue}
                ></MenuAppBar>
            </div> 
            </div>
        );
    }
}
const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
  }));

  const useStylesSlide = makeStyles(theme => ({
    appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
  }));
  
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
  });
function MenuAppBar(props) {
    //всплывающее меню
    const classesS = useStylesSlide();
    const [openS, setOpenS] = React.useState(false);

    const handleClickOpenS = event => {
        setOpenS(true);
    };
    const constSelect = (event,id) => {
        props.handleListItemClick(event, id);
        setOpenS(false);
    };
    const handleCloseS = event => {
        setOpenS(false);
    };

    //верхняя панель 
    const classes = useStyles();
    const {theme, ukr, rus, tr, selectedIndex} = props 
    return ( 
      <div className={classes.root}>
        <ThemeProvider theme={ThemeAppBar}>
        <AppBar className="AppBarMobile">
          <Toolbar>
            <IconButton edge="start" className={classes.menuButton} onClick={handleClickOpenS} color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {tr.Personalaccount}
            </Typography>
            {/*auth && (
              <div>
                  <ListItem>
                  <AccountCircle style={{color: themeColorLogoMobile.color}}></AccountCircle>
                    <label style={{marginLeft: 10}} className="username">{props.user.data.name}</label>
                  </ListItem>
              </div>
            )*/}
          </Toolbar>
        </AppBar>
        
        <Dialog 
        fullScreen 
        classes={{
            paper: "MuiDialog-paperFullScreen"
        }}
        open={openS} 
        onClose={handleCloseS} 
        TransitionComponent={Transition}>
          <AppBar className={classesS.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={handleCloseS} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classesS.title}>
                {tr.Menu}
              </Typography>
            </Toolbar>
          </AppBar>
          <List>
                    <div>
                        <User show_username_logo_fio={AppliedSettings.show_username_logo_fio} user={props.user}></User>
                    </div>
                {AppliedSettings.show_statistics_page &&
                <Link to={baseUrl + "/stats"} className="LinkNavigation">
                    <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 0}
                        onClick={event => constSelect(event, 0)}
                    >
                    <ListItemIcon>
                        <ViewListIcon className="IconMenu"/>
                    </ListItemIcon>
                        <ListItemText primary={tr.Statistics} />
                    </ListItem>
                </Link>
                }
                {AppliedSettings.show_operations_page &&
                <Link to={baseUrl + "/operations"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 1}
                        onClick={event => constSelect(event, 1)}
                        >
                            <ListItemIcon>
                                <WatchLaterIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Operations} />
                        </ListItem>
                    </Link>
                }
                {AppliedSettings.show_cashback_page &&
                    <Link to={baseUrl + "/cashback"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 2}
                        onClick={event => constSelect(event, 2)}
                        >
                            <ListItemIcon>
                                <MonetizationOnIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Cashback} />
                        </ListItem>
                    </Link>
                }
                {AppliedSettings.show_transferring_funds_page &&
                    <Link to={baseUrl + "/transferringFunds"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 3}
                        onClick={event => constSelect(event, 3)}
                        >
                            <ListItemIcon>
                                <SyncAltIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.TransferMoney} />
                        </ListItem>
                    </Link>
                }
                {AppliedSettings.show_limits_page &&
                    <Link to={baseUrl + "/limits"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 4}
                        onClick={event => constSelect(event, 4)}
                        >
                            <ListItemIcon>
                                <CreditCardIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Limits} />
                        </ListItem>
                    </Link>
                }
                {AppliedSettings.show_clientInfo_page &&
                    <Link to={baseUrl + "/clientInfo"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 5}
                        onClick={event => constSelect(event, 5)}
                        >
                            <ListItemIcon>
                                <SupervisorAccountIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Profile} />
                        </ListItem>
                    </Link>
                }
                {AppliedSettings.show_security_page &&
                    <Link to={baseUrl + "/security"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 6}
                        onClick={event => constSelect(event, 6)}
                        >
                            <ListItemIcon>
                                <VerifiedUserIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.Security} />
                        </ListItem>
                    </Link>
                }
                    <Divider />
            </List>
            <List>
            {AppliedSettings.show_night_thema &&
                        <ListItem className="LinkNavigationBG">
                            <ListItemIcon>
                                <NightsStayIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText id="switch-list-label-nightmode" primary={tr.NightMode} />
                            <ListItemSecondaryAction>
                                <ThemeSwitch 
                                onClick={props.changeTheme}
                                checked={theme == 'light' | theme == null ? false : true}
                                color="primary"
                                />
                            </ListItemSecondaryAction>
                        </ListItem> 
            }
            {AppliedSettings.show_language_panel &&
                    <Link className="LinkNavigation">
                    <ListItem className="LinkNavigationBG" button onClick={props.ChangeLanguage}
                    >
                            <ListItemIcon>
                                <LanguageIcon className="IconMenu"/>
                            </ListItemIcon>
                            <Label style={ukr} textLabel={AppliedSettings.language_first}></Label>
                            <Label className="LabelLang" textLabel="/"></Label>
                            <Label style={rus} textLabel={AppliedSettings.language_second}></Label>
                        </ListItem>     
                    </Link> 
            }  
                    <Divider /> 
                    <Link to={baseUrl + "/about"} className="LinkNavigation">
                        <ListItem 
                        className="LinkNavigationBG"
                        button
                        selected={selectedIndex === 7}
                        onClick={event => constSelect(event, 7)}
                        >
                            <ListItemIcon>
                                <VerifiedUserIcon className="IconMenu"/>
                            </ListItemIcon>
                            <ListItemText primary={tr.About} />
                        </ListItem>
                    </Link>       
                    {[tr.Exit].map((text) => (
                    <ListItem className="LinkNavigationBG" button key={text} 
                    onClick={props.onExitApp}
                    >
                        <ListItemIcon>{<ExitToAppIcon className="IconMenu"/>}</ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItem>
                    ))}
                </List>
        </Dialog></ThemeProvider>
      </div>
    );
  }
export default Navigation;
export {
    Navigation
}